import { Spinner } from "@astryxdesign/core";
import * as stylex from "@stylexjs/stylex";

const styles = stylex.create({
  fullscreen: {
    minHeight: "100dvh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 12,
  },
});

export function FullScreenLoader({ label }: { label?: string }) {
  return (
    <div {...stylex.props(styles.fullscreen)}>
      <Spinner size="lg" label={label} />
    </div>
  );
}
